module.exports = __webpack_public_path__ + "media/icons/linkedin-black-d175ed12.png";